/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import config from "../../../../../../config.json"; // ajuste le chemin si nécessaire
import { useTranslation } from "react-i18next";
import axios from "axios";
import videImg from "../../../../../assets/images/vide-item.png";
import "./Subgategories.css";
import { subcategoryTitle } from "../../../Cms/MenuTree/menuTreeUtils";

const Subcategories = ({
  subcategory,
  fetchSubcategories,
  selected = false,
  onToggleSelect,
}) => {
  const { t } = useTranslation();
  const { _id, bannerImage, subCategoryDetails = [], isArchived } = subcategory;

  const [displayOrientation, setDisplayOrientation] = useState(
    subcategory.displayOrientation === "horizontal" ? "horizontal" : "vertical"
  );
  const [orientationSaving, setOrientationSaving] = useState(false);

  useEffect(() => {
    setDisplayOrientation(
      subcategory.displayOrientation === "horizontal" ? "horizontal" : "vertical"
    );
  }, [subcategory.displayOrientation, _id]);

  const setDisplayOrientationTo = async (next) => {
    if (next === displayOrientation || orientationSaving) return;
    setOrientationSaving(true);
    try {
      await axios.put(
        `${config.dev}/v2/subcategories/update/${_id}`,
        { displayOrientation: next },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
          },
        }
      );
      setDisplayOrientation(next);
      fetchSubcategories();
      swal(t("successTitle"), t("subcategoryUpdated"), "success");
    } catch (error) {
      swal("ERROR", error?.response?.data?.message || String(error), "error");
    } finally {
      setOrientationSaving(false);
    }
  };

  const hideSubcategory = async () => {
    try {
      await axios.put(
        `${config.dev}/v2/subcategories/${_id}/archive`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
          },
        }
      );
      swal("SUCCESS", "Subcategory is in hide mode", "success");
      fetchSubcategories();
    } catch (error) {
      swal("ERROR", "" + error, "error");
    }
  };

  if (isArchived) return null;

  const englishTitle = subcategoryTitle({ subCategoryDetails }, "");

  return (
    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4">
      <div className={`card kitchen-card${selected ? " is-selected" : ""}`}>
        <div className="card-body">
          <div className="kitchen-card__top">
            <input
              type="checkbox"
              className="kitchen-card__check"
              checked={selected}
              onChange={() => onToggleSelect?.(_id)}
              aria-label={t("selectAll")}
            />
            <div className="kitchen-card__menu">
            <Dropdown>
              <Dropdown.Toggle
                variant="outline-secondary"
                className="btn-sm"
                id="subcategory-actions"
              >
                <i className="fas fa-ellipsis-v" />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  as={Link}
                  to={`/subcategory-details/${_id}`}
                  className="kitchen-action-view"
                >
                  <i className="fas fa-eye me-2" />
                  {t("details")}
                </Dropdown.Item>
                <Dropdown.Item
                  as={Link}
                  to={`/edit-subcategory/${_id}`}
                  className="text-warning"
                >
                  <i className="fas fa-pen me-2 text-warning" />
                  {t("edit")}
                </Dropdown.Item>
                <Dropdown.Item onClick={hideSubcategory} className="text-danger-dark">
                  <i className="fas fa-archive me-2 text-danger-dark" />
                  {t("archive")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            </div>
          </div>

          <div className="new-arrivals-img-contnent kitchen-card__media">
            <img
              className="img-fluid"
              src={
                bannerImage
                  ? `${config.UPLOADS_SERVER}/category/${bannerImage}`
                  : videImg
              }
              alt={englishTitle || ""}
            />
          </div>

          <div className="kitchen-card__title text-center">
            <h4>{englishTitle || t("noTitle")}</h4>
            <div className="mt-3 px-1">
              <div className="text-center small text-muted mb-2 fw-semibold">
                {t("displayOrientation")}
              </div>
              <div
                className="subcategory-orient-switch"
                role="group"
                aria-label={t("displayOrientation")}
              >
                <button
                  type="button"
                  className={`subcategory-orient-switch__option${
                    displayOrientation === "vertical" ? " is-active" : ""
                  }`}
                  aria-pressed={displayOrientation === "vertical"}
                  disabled={orientationSaving}
                  title={t("switchToVertical")}
                  onClick={() => setDisplayOrientationTo("vertical")}
                >
                  <i
                    className="fas fa-grip-vertical subcategory-orient-switch__icon"
                    aria-hidden={true}
                  />
                  <span>{t("vertical")}</span>
                </button>
                <button
                  type="button"
                  className={`subcategory-orient-switch__option${
                    displayOrientation === "horizontal" ? " is-active" : ""
                  }`}
                  aria-pressed={displayOrientation === "horizontal"}
                  disabled={orientationSaving}
                  title={t("switchToHorizontal")}
                  onClick={() => setDisplayOrientationTo("horizontal")}
                >
                  <i
                    className="fas fa-grip-horizontal subcategory-orient-switch__icon"
                    aria-hidden={true}
                  />
                  <span>{t("horizontal")}</span>
                </button>
              </div>
              <div className="text-muted text-center mt-2" style={{ fontSize: "11px" }}>
                {displayOrientation === "horizontal"
                  ? t("subcategoryShownHorizontally")
                  : t("subcategoryShownVertically")}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Subcategories;
